import {createAction, createReducer} from 'redux-act';

import {ApplicationStoreType} from 'reducers';

import {CategoryProductType} from 'constants/flow/flowTypesCategory';

export type ExpandCategoryProductType = CategoryProductType & {position: number; category: string};

export const initialState: ExpandCategoryProductType = [];

/**
 * List of actions
 */
export const setCurrentProducts = createAction<ExpandCategoryProductType>('SET_CURRENT_PRODUCTS');
export const clearCurrentProducts = createAction('CLEAR_CURRENT_PRODUCTS');

/**
 * Current products reducer
 */
export const currentProducts = createReducer({}, initialState)
    .on(setCurrentProducts, (_, payload) => payload)
    .on(clearCurrentProducts, () => initialState);

/**
 * Return current products
 *
 * @param {ApplicationStoreType} store - redux store
 * @returns {ExpandCategoryProductType} - current products
 */
export const getCurrentProducts = (store: ApplicationStoreType): ExpandCategoryProductType =>
    store.currentProducts;
